/**
 * A股顶部基本信息
 */
import React from "react"
import { store } from "./store"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { Observer } from "mobx-react-lite"
import { LoadMore } from "../../shared/quote_load_more"
import { ChartType } from "../../shared/utils"
import { PageType, StockSubType, StockErrorTradeStatus } from "../../shared/pagetype"
import { quotedata } from "../../shared/quotedata"
import { PanKouLoadMore } from "./pe_load_more"
import { StockHeaderErrorTradeStatus } from "../../shared/error_trade_status"

export function ABasicInfo(props: { stocksubtype: StockSubType; quotedata: quotedata; pagetype: PageType; trade_status: StockErrorTradeStatus }) {
  return (
    <Observer>
      {() => (
        <div className="datas">
          <div className="top-p">
            <StockHeaderErrorTradeStatus store={store} trade_status={props.trade_status}/>
            <div>
              <div className="row">
                {store.chartType != ChartType.分时 && store.chartType != ChartType.五日 && store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>今开</span>
                      {quote_chart[quote_item_name.今开](store.chart_mouse_move_data.jinkai, store.chart_mouse_move_data.jkColor).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {quote_chart[quote_item_name.最高](store.chart_mouse_move_data.maxPrice, store.chart_mouse_move_data.maxPriceColor).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {quote_chart[quote_item_name.最低](store.chart_mouse_move_data.minPrice, store.chart_mouse_move_data.minPriceColor).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>今开</span>
                      {single_quote[quote_item_name.今开](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {single_quote[quote_item_name.最高](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {single_quote[quote_item_name.最低](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
              <div className="row">
                {store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>换手</span>
                      {quote_chart[quote_item_name.换手](store.chart_mouse_move_data.huanshou).element}
                    </p>
                    <p>
                      <span>总手</span>
                      {quote_chart[quote_item_name.总手](store.chart_mouse_move_data.zongshou).element}
                    </p>
                    <p>
                      <span>金额</span>
                      {quote_chart[quote_item_name.成交额](store.chart_mouse_move_data.amount).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>换手</span>
                      {single_quote[quote_item_name.换手](store.StockDetail).element}
                    </p>
                    <p>
                      <span>总手</span>
                      {single_quote[quote_item_name.总手](store.StockDetail).element}
                    </p>
                    <p>
                      <span>金额</span>
                      {single_quote[quote_item_name.成交额](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-p">
            {!store.chart_mouse_move_data && (
              <>
                <p>
                  <span>总值</span>
                  {single_quote[quote_item_name.总市值](store.StockDetail).element}
                </p>
                <p>
                  <span>流值</span>
                  {single_quote[quote_item_name.流通市值](store.StockDetail).element}
                </p>
                <p>
                  <span>市盈</span>
                  <sup className={single_quote[quote_item_name["市盈率(动)"]](store.StockDetail).source.toString().length > 4 ? `special-dynamic-sup` : "dynamic-sup"}>动</sup>
                  <PanKouLoadMore detail_data={store.StockDetail}/>
                  {single_quote[quote_item_name["市盈率(动)"]](store.StockDetail).element}
                </p>
              </>
            )}
            {props.stocksubtype != StockSubType.创业板 && props.stocksubtype != StockSubType.科创板 && props.stocksubtype != StockSubType.北证A股 && store.chartType != ChartType.日K && store.chart_mouse_move_data && (
              <>
                <p>
                  <span>总值</span>
                  {quote_chart[quote_item_name.总市值](store.StockDetail).element}
                </p>
                <p>
                  <span>流值</span> {quote_chart[quote_item_name.流通市值](store.StockDetail).element}
                </p>
                <p>
                  <span>市盈</span>
                  <sup className={single_quote[quote_item_name["市盈率(动)"]](store.StockDetail).source.toString().length > 4 ? `special-dynamic-sup` : "dynamic-sup"}>动</sup>
                  <PanKouLoadMore detail_data={store.StockDetail} />
                  {quote_chart[quote_item_name["市盈率(动)"]](store.StockDetail).element}
                </p>
              </>
            )}
            {(props.stocksubtype == StockSubType.创业板 || props.stocksubtype == StockSubType.科创板) && !(store.chartType == ChartType.日K || store.chartType == ChartType.周K || store.chartType == ChartType.月K) && store.chart_mouse_move_data && (
              <>
                <p>
                  <span>总值</span>
                  {quote_chart[quote_item_name.总市值](store.StockDetail).element}
                </p>
                <p>
                  <span>流值</span> {quote_chart[quote_item_name.流通市值](store.StockDetail).element}
                </p>
                <p>
                  <span>市盈</span>
                  <sup className={single_quote[quote_item_name["市盈率(动)"]](store.StockDetail).source.toString().length > 4 ? `special-dynamic-sup` : "dynamic-sup"}>动</sup>
                  <PanKouLoadMore detail_data={store.StockDetail} />
                  {quote_chart[quote_item_name["市盈率(动)"]](store.StockDetail).element}
                </p>
              </>
            )}
            {(props.stocksubtype == StockSubType.创业板 || props.stocksubtype == StockSubType.科创板) && store.chartType == ChartType.日K && store.chart_mouse_move_data && (
              <>
                <p>
                  {quote_chart[quote_item_name.日K时间](store.chart_mouse_move_data.time).element}
                  <span></span>
                </p>
                <p>
                  <span>盘后量</span>
                  {quote_chart[quote_item_name.盘后量](store.chart_mouse_move_data).element}
                </p>
                <p>
                  <span>盘后额</span>
                  {quote_chart[quote_item_name.盘后额](store.chart_mouse_move_data).element}
                </p>
              </>
            )}
            {(props.stocksubtype == StockSubType.沪市主板 || props.stocksubtype == StockSubType.深市主板 || props.stocksubtype == StockSubType.北证A股) && store.chartType == ChartType.日K && store.chart_mouse_move_data && (
              <>
                <p>
                  {quote_chart[quote_item_name.日K时间](store.chart_mouse_move_data.time).element}
                  <span></span>
                </p>
                <p></p>
                <p></p>
              </>
            )}
            {props.stocksubtype == StockSubType.北证A股 && store.chartType != ChartType.日K && store.chart_mouse_move_data && (
              <>
                <p>
                  <span>总值</span>
                  {quote_chart[quote_item_name.总市值](store.StockDetail).element}
                </p>
                <p>
                  <span>流值</span> {quote_chart[quote_item_name.流通市值](store.StockDetail).element}
                </p>
                <p>
                  <span>市盈</span>
                  <sup className={single_quote[quote_item_name["市盈率(动)"]](store.StockDetail).source.toString().length > 4 ? `special-dynamic-sup` : "dynamic-sup"}>动</sup>
                  <PanKouLoadMore detail_data={store.StockDetail}/>
                  {quote_chart[quote_item_name["市盈率(动)"]](store.StockDetail).element}
                </p>
              </>
            )}
            {(props.stocksubtype == StockSubType.创业板 || props.stocksubtype == StockSubType.科创板) && (store.chartType == ChartType.周K || store.chartType == ChartType.月K) && store.chart_mouse_move_data && (
              <>
                <p>
                  <span>总值</span>
                  {quote_chart[quote_item_name.总市值](store.StockDetail).element}
                </p>
                <p>
                  <span>盘后量</span>
                  {quote_chart[quote_item_name.盘后量](store.chart_mouse_move_data).element}
                </p>
                <p>
                  <span>盘后额</span>
                  {quote_chart[quote_item_name.盘后额](store.chart_mouse_move_data).element}
                </p>
              </>
            )}
            <LoadMore />
          </div>
        </div>
      )}
    </Observer>
  )
}
